import { render } from "./DetailsIcon.vue?vue&type=template&id=e3cf8d00"
import script from "./DetailsIcon.vue?vue&type=script&lang=js"
export * from "./DetailsIcon.vue?vue&type=script&lang=js"
script.render = render

export default script